<template>
<div class="nft_wrapper full" id="myNft">
    <!-- title -->
    <div class="main_top">
      <h1>
        <img src="images/basic/icon/back-w.svg" onclick="history.back()" class="back" />
        내 NTF <span class="count">{{userInfo.nftCount}}</span>
      </h1>
      <a class="h1_div"> </a>
    </div>
    <div class="dashboard">
       <div class="div_padding"></div>
      <div class="text" :style="!disableFunction ? 'visibility: hidden;' : 'visibility: visible;'" >
        <h1>₩ 14,000,000</h1>
        <div class="detail">
          <p>NFT Holder Roulette 200만</p>
          <p>NFT Holder Slot 200만</p>
          <p>NFT Holder Dice 200만</p>
        </div>
      </div>
      <div class="wall"></div>
    </div>
   
    <div class="stat">
      <ul class="list horizon">
        <li class="line1px-bottom point">
          <h4>보유 포인트</h4>
          <div class="text single">
            <p>ⓟ <span>{{userInfo.nftPointView}}</span></p>
            <!--<a ><img src="images/basic/icon/exchange.svg" alt=""></a>-->
          </div>
        </li>
        <!-- class="line1px-bottom" 하단 line 1px calss --> 
        <li onclick="location.href='/pointList'">
          <div class="text single"><p>포인트 적립내역</p><a href="#"><img src="images/basic/icon/arrow-right-thin.svg" alt=""></a></div>
        </li>
        <!--
        <li>
          <div class="text single"><p>광고보상 자동채굴</p>
            <div class="switch" v-bind:class="{ on:autoMiningFlag }"></div>
          </div>
        </li>
        -->
      </ul>
      <ul class="list horizon">
        <li class="items">
          <h4>보유 NFT</h4>
          <ul class="item">
            <li class="line1px-bottom" v-for="(nft , index) in resultList" :key="index">
              <div class="thumb">
                <!-- <img :src="`https://tapi.thehae.biz/asset/images/nft/nft${nft.nftType}.png`" alt=""> -->
                <!-- <img :src="`https://api.thehae.biz/asset/images/nft/nft${nft.nftTypeCode}.png`" alt=""> -->
                <img :src="`/asset/images/nft/nft${nft.nftTypeCode.replace('NFT','')}.png`" alt="">
              </div>
              <div class="text">
                <h3>{{nft.nftSn}}</h3>
                <template v-if="nft.nftDownPaymentDate != undefined & nft.nftDownPaymentDate != ''">
                  <p>{{nft.nftBalanceDate}}일까지 할부 납부</p>
                  <p class="remain"><span>{{nft.nftDownPayment}}</span> / {{nft.nftBalance}}</p>
                </template>
                <template v-else>
                  <p class="price">₩ {{(nft.nftTypeCode.replace('NFT','')*10000).toLocaleString('ko-KR')}}</p>
                </template>
                <p class="date">{{nft.nftRegDate}} 구매</p>
              </div>
            </li>
            <!--
            <li class="line1px-bottom">
              <div class="thumb">
                <img src="images/basic/img/nft-roulette.png" alt="">
              </div>
              <div class="text">
                <p class="sr">SR: 1baetR1aksdYB</p>
                <h3>NFT Holder Roulette</h3>
                <p class="price">₩ 20,000,000</p>
                <p class="date">2022.03.14 PM 07:32</p>
              </div>
            </li>
            <li class="line1px-bottom">
              <div class="thumb">
                <img src="images/basic/img/nft-roulette-b.png" alt="">
              </div>
              <div class="text">
                <p class="sr">SR: 1baetR1aksdYB</p>
                <h3>NFT Holder Roulette</h3>
                <p class="price">₩ 100,000,000</p>
                <p class="date">2022.03.14 PM 07:32</p>
              </div>
            </li>
            <li class="line1px-bottom">
              <div class="thumb">
                <img src="images/basic/img/nft-slot.png" alt="">
              </div>
              <div class="text">
                <p class="sr">SR: 1baetR1aksdYB</p>
                <h3>NFT Holder Slot</h3>
                <p class="price">₩ 20,000,000</p>
                <p class="date">2022.03.14 PM 07:32</p>
              </div>
            </li>
            <li class="line1px-bottom">
              <div class="thumb">
                <img src="images/basic/img/nft-slot-b.png" alt="">
              </div>
              <div class="text">
                <p class="sr">SR: 1baetR1aksdYB</p>
                <h3>NFT Holder Slot</h3>
                <p class="price">₩ 100,000,000</p>
                <p class="date">2022.03.14 PM 07:32</p>
              </div>
            </li>
            <li class="line1px-bottom">
              <div class="thumb">
                <img src="images/basic/img/nft-dice.png" alt="">
              </div>
              <div class="text">
                <p class="sr">SR: 1baetR1aksdYB</p>
                <h3>NFT Holder Dice</h3>
                <p class="price">₩ 20,000,000</p>
                <p class="date">2022.03.14 PM 07:32</p>
              </div>
            </li>
            <li class="line1px-bottom">
              <div class="thumb">
                <img src="images/basic/img/nft-dice-b.png" alt="">
              </div>
              <div class="text">
                <p class="sr">SR: 1baetR1aksdYB</p>
                <h3>NFT Holder Dice</h3>
                <p class="price">₩ 100,000,000</p>
                <p class="date">2022.03.14 PM 07:32</p>
              </div>
            </li>
            -->
          </ul>
        </li>
        <li>
          <div class="text single" onclick="location.href='/purchaseList'">
            <p>NFT 구매내역</p><a ><img src="images/basic/icon/arrow-right-thin.svg" alt=""></a>
            </div>
        </li>
      </ul>
      <ul class="list horizon" >
        <!--
        <h4  class="line1px-bottom alone">할부 납부 관리</h4>
        <li v-for=" (nftReq, index ) in buyNftReqList" :key="index" :class="nftReq.buyStatus == 'Y'? 'line1px-bottom complete' : 'line1px-bottom'">
          <template v-if="nftReq.buyStatus == 'Y'">
            <div class="text single">{{nftReq.title}}</div>
            <div class="text single remaining"><p>{{nftReq.trxAmount}} </p><a href="#" class="btn-small">완납</a></div>
          </template>
          <template v-else>
            <div class="text single">{{nftReq.title}} <span class="date">~????.??,??</span></div>
            <div class="text single remaining"><p><span class="remain">{{nftReq.krwAmount}}</span> / {{nftReq.trxAmount}} </p><a class="btn-small">납부</a></div>
          </template>
        </li>
        <li>
          <div class="exp">
            중도금은 수익금으로 자동 납부 가능하며, 계약만료일(1년) 이내에 잔금 완납을 완료하셔야 하며 미 완료시 NFT가 회수됩니다.
          </div>
        </li>
        -->
      </ul>
    </div>
</div>
</template>

<script>
import $ from 'jquery'
import { fetchMiningInfo, setAutoMining, buyNftRequest, fetchBuyNftReqList, fetchBuyInfo } from "@/api/nft";
export default {
  data() {
     return{
        autoMiningFlag:false,
        resultList:[],
        buyNftReqList:[],
        disableFunction: false // 1차 오픈 hidden 처리
     }
  },
  computed: {
    userInfo(){
      var user = this.$store.state.userInfo;
      return user;
    },
  },
  created() {
    this.getAutoMiningInfo();
    this.getBuyInfo();
    this.getBuyNftReqList();
  },
  mounted() {
    window.VueRoot = this;
    $(document).ready(function(){
      $('.switch').click(function(){
        $(this).toggleClass('on');
        var autoMining = $(this).hasClass('on') ? "Y" : "N";
        window.VueRoot.updateAutoMining(autoMining);
      })
    });
    $(window).scroll(function(){ 
      var height = $(document).scrollTop(); //실시간으로 스크롤의 높이를 측정
      if(height > 0){ 
        $('body').addClass('scrolled'); 
      }else if(height == 0){ 
        $('body').removeClass('scrolled'); 
      } 
    });
  },
  methods: {
    getAutoMiningInfo() {
      fetchMiningInfo( )
        .then(({ data }) => {
          this.autoMiningFlag = data.autoMiningFlag == "Y";
        })
    },
    /**
     * NFT 자동채굴 설정변경
     * @param autoMining = "Y" , "N" String
     */
    updateAutoMining(autoMining) {
      setAutoMining({autoMining: autoMining})
      .then(({ data }) => {
          console.log("---------setAutoMining")
          console.log(data);
      })
    },
    
    getBuyInfo() {
      fetchBuyInfo()
        .then(({ data }) => {
          console.log("---------fetchBuyInfo")
          console.log(data);

          this.resultList = data.resultList;
        })
    },

    getBuyNftReqList(){
      fetchBuyNftReqList()
      .then(({ data }) => {
        if(data.resultCode == 1000){
         console.log("---------fetchBuyNftReqList")
          console.log(data);
          this.buyNftReqList = data.resultList;

          this.buyNftReqList.forEach((buyNftReq) =>{
            buyNftReq.title = buyNftReq.nftType + "만 NFT"; 
          }) 
        }
      })
    }
  }
}
</script>
<style scoped>
/* 독립적으로 스타일 적용 */
</style>